<template>
  <i-modal
    modal-id="saml-modal"
    :title="title"
    :confirm-button-text="action === 'createIdentityProvider' ? 'Add' : 'Edit'"
    :submit-on-enter="true"
    :input-focus-on-open="true"
    :close-on-submit="false"
    @on-close="goBack"
    @on-submit="submit"
  >
    <template #body-content>
      <!-- Error Display -->
      <div v-if="errors && errors.length > 0" class="errors-container i-mb-6">
        <div
          v-for="(error, index) in errors"
          :key="index"
          class="error-message i-text-error-90 i-p-4 i-radius-md"
        >
          {{ error.message || error }}
        </div>
      </div>

      <div v-if="!!identityProvider" class="d-flex flex-column i-gap-6">
        <i-text-input
          id="idp_name"
          :model-value="identityProvider.name"
          label="Identity Provider Name:"
          placeholder="Enter Identity Provider Name"
          @update:model-value="identityProvider.name = $event"
        ></i-text-input>

        <i-text-input
          id="idp_entity_id"
          :model-value="identityProvider.entity_id"
          label="Identity Provider Entity ID:"
          placeholder="Enter Entity ID"
          @update:model-value="identityProvider.entity_id = $event"
        ></i-text-input>

        <i-text-input
          id="idp_sso_url"
          :model-value="identityProvider.single_sign_on_url"
          label="Identity Provider Single-Sign-On URL:"
          placeholder="Enter Single Sign On URL"
          @update:model-value="identityProvider.single_sign_on_url = $event"
        ></i-text-input>

        <i-text-input
          id="idp_x509_cert"
          :model-value="identityProvider.idp_cert"
          label="Identity Provider X509 Cert:"
          :placeholder="
            identityProvider.idp_cert_fingerprint ||
            'Enter Identity Provider X509 Certificate'
          "
          :mode="iTextInputModes.TEXTAREA"
          @update:model-value="identityProvider.idp_cert = $event"
        ></i-text-input>

        <div class="i-text-neutral-120 i-text-subheading-2">
          Advanced Settings for Identity Provider:
        </div>
        <i-checkbox
          :model-value="identityProvider.sign_metadata"
          label="Sign metadata"
          input-value="checked"
          @update:model-value="identityProvider.sign_metadata = $event"
        />

        <i-checkbox
          :model-value="identityProvider.want_messages_signed"
          label="Sign messages"
          input-value="checked"
          @update:model-value="identityProvider.want_messages_signed = $event"
        />

        <i-checkbox
          :model-value="identityProvider.authn_requests_signed"
          label="Sign AuthN requests"
          input-value="checked"
          @update:model-value="identityProvider.authn_requests_signed = $event"
        />

        <i-checkbox
          :model-value="identityProvider.want_assertions_signed"
          label="Assertions from IdP should be signed"
          input-value="checked"
          @update:model-value="identityProvider.want_assertions_signed = $event"
        />

        <i-checkbox
          :model-value="identityProvider.want_assertions_encrypted"
          label="Assertions from IdP should be encrypted"
          input-value="checked"
          @update:model-value="
            identityProvider.want_assertions_encrypted = $event
          "
        />
      </div>
    </template>
  </i-modal>
</template>

<script>
import {
  iCheckbox,
  iModal,
  iTextInput,
  iTextInputModes,
  openModal,
} from '@inscribe/signal';

export default {
  components: { iCheckbox, iModal, iTextInput },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.rootScreen = from.fullPath === '/';
    });
  },
  props: {
    model: {
      type: Object,
      default: undefined,
    },
    action: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      identityProvider: this.model,
      iTextInputModes,
      tag: '',
    };
  },
  mounted() {
    openModal('saml-modal');
  },
  methods: {
    submit: function () {
      this.$emit(this.action, this.identityProvider);
    },
    goBack() {
      this.$router.push({
        name: 'saml-settings-view',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.error-message {
  background-color: $light-error-30;
  border: 1px solid $light-error-80;
}
</style>
